module.exports = __webpack_public_path__ + "source-sans-pro-v10-latin-ext_latin-700.ec6bc1d732e58f84e2fd.woff2";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/accessibility/layout/fonts/source-sans-pro-v10-latin-ext_latin-700.woff2
// module id = ../../../../../src/assets/accessibility/layout/fonts/source-sans-pro-v10-latin-ext_latin-700.woff2
// module chunks = styles